import { NgModule, isDevMode } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreloadSelectedModules } from './preload-selected-modules';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { adminGuard } from './modules/core/guards/admin.guard';
import { superadminGuard } from './modules/core/guards/superadmin.guard';
import { VerifyLoginTokenComponent } from './components/verify-login-token/verify-login-token.component';
import { SignupComponent } from './components/signup/signup.component';
import { VerifyAccountComponent } from './components/verify-account/verify-account.component';
import { SignupConfirmationComponent } from './components/signup-confirmation/signup-confirmation.component';

const routes: Routes = [

  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, data: { showHeader: false, showFooter: false } },
  { path: 'forgot-password', component: LoginComponent, data: { showHeader: false, showFooter: false, isForget: true } },
  { path: 'reset-password/:uuid', component: ResetPasswordComponent },
  { path: 'verify-account/:uuid', component: VerifyAccountComponent },
  { path: 'verify-login-token', component: VerifyLoginTokenComponent, data: { showHeader: false, showFooter: false } },
  { path: 'signup', component: SignupComponent },
  { path: 'signup/:uuid', component: SignupComponent },
  { path: 'signup-confirmation/:id', component: SignupConfirmationComponent },
  {
    path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [adminGuard], data: { preload: true }
  },
  {
    path: 'superadmin', loadChildren: () => import('./modules/superadmin/superadmin.module').then(m => m.SuperadminModule),
    canActivate: [superadminGuard], data: { preload: true, delay: 2000 }
  },
  { path: 'not-found', pathMatch: 'full', component: NotFoundComponent, data: { showHeader: false, showFooter: false } },
  { path: '**', pathMatch: 'full', redirectTo: '/not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      {
        useHash: false,
        preloadingStrategy: !isDevMode() ? PreloadSelectedModules : null,
        scrollPositionRestoration: 'enabled'
      }
    ),
  ],
  exports: [RouterModule],
  providers: [PreloadSelectedModules],
})
export class AppRoutingModule { }
